import { render, staticRenderFns } from "./ex-company-list.vue?vue&type=template&id=46c0fb4d&scoped=true&"
import script from "./ex-company-list.vue?vue&type=script&lang=js&"
export * from "./ex-company-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-company-list.vue?vue&type=style&index=0&id=46c0fb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c0fb4d",
  null
  
)

export default component.exports